import { on_ready, is_elementor_edit } from 'js/utils';
import { retina_init } from 'js/retina';
import { toggle_height_init } from 'js/toggle_height_init';
import { load_swiper_check } from 'modules/carousel/load_swiper';
import { header_init } from 'modules/header/header';
import forms_init from 'modules/forms/forms';
import carousels_init from 'modules/carousel/carousel';
import footer_init from 'modules/footer/footer';
import nav_menu_init from 'modules/menu/nav/nav';
import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import 'js/tab-to-dropdown';

// load global styles
import './main.scss';

on_ready(()=>{

    on_elementor_edit_screen();
    
    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    forms_init(); 

    load_swiper_mobile();

    const tasks = [
        load_swiper_check,
        header_init,
        nav_menu_init,
        carousels_init, // swiper
        retina_init, // load @2x images
        toggle_height_init, // toggle element height from 0 to default - for animating height
        on_mobile,
        load_more_testimonials,
        
        
    ];
    tasks.forEach(task=>setTimeout(task, 0));
    
    dynamic_load_init();

    // For Elementor Carousel widgets
    // window.addEventListener('load', () => {
    //     if (
    //         typeof elementorFrontend !== 'undefined' &&
    //         typeof elementorFrontend.init === 'function'
    //     ) {
    //         console.log('[debug] Forcing Elementor widgets to re-init (working safe version)');

    //         requestAnimationFrame(() => {
    //             try {
    //                 elementorFrontend.init(); 
    //             } catch (e) {
    //                 console.error('[error] Elementor init failed:', e);
    //             }
    //         });
    //     }
    // });

    document.dispatchEvent(new Event('after_main_ready'));
});

function on_elementor_edit_screen(){
    footer_init();
}

function on_mobile(){
    if( window.innerWidth > 768 ) return;
    close_footer_dropdowns();
    closed_accordion_mobile();
}

function close_footer_dropdowns(){
    document.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open').forEach(dropdown=>{
        dropdown.click();
    })
}

function load_more_testimonials() {
    if (window.innerWidth <= 768) return; 

    var num = 3;
    var container = jQuery('.testimonial_overview .grid');
    var items = container.find('.item-testimonial-2');
    var item_index = 0;
    var interval = 190;

    if (items.length <= num) return;

    // Hide items initially
    items.addClass('hide');

    // Load initial items
    load_items();

    // Add load more button
    container.after('<div class="load-more-container"><div class="load-more-btn btn small">Load more</div></div>');

    // Load more on click
    jQuery('.load-more-btn').on('click', load_items);

    function load_items() {
        for (var i = 0; i < num; i++) {
            jQuery(items[item_index]).removeClass('hide');
            item_index++;
            if (item_index >= items.length) {
                jQuery('.load-more-container').remove();
                break;
            }
        }
    }
}

function closed_accordion_mobile() {
    const is_mobile = window.innerWidth < 768;
    
    if (!is_mobile) return;

    const delay = 100;
    setTimeout(() => {
        jQuery('.e-n-accordion-item').removeAttr('open');
    }, delay);
}

function dynamic_load_init(){

    // search popup: remove if not used
    if( document.querySelector('.search_popup_open') ) {
        import('modules/search/search_popup/init');
    }
    
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    // if( document.querySelector('.compare_count') ||
    //     document.querySelector('.wishlist_count') ) {
    //     import('modules/save_items/init');
    // }

    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}